import type { AdaptationCycleBaseConfig, AdaptationCycleStageConfig } from '../types'
import { adaptationCycleOverview } from './adaptation-cycle-overview.config'
import { adaptationCycleStageOne } from './adaptation-cycle-stage-one.config'
import { adaptationCycleStageTwo } from './adaptation-cycle-stage-two.config'
import { adaptationCycleStageThree } from './adaptation-cycle-stage-three.config'
import { adaptationCycleStageFour } from './adaptation-cycle-stage-four.config'

export const ADAPTATION_CYCLE: AdaptationCycleBaseConfig[] = [
  adaptationCycleOverview,
  adaptationCycleStageOne,
  adaptationCycleStageTwo,
  adaptationCycleStageThree,
  adaptationCycleStageFour,
]

export const ADAPTATION_CYCLE_MAP = Object.fromEntries(
  ADAPTATION_CYCLE.map((ac) => [ac.id, ac]),
) as Record<string, AdaptationCycleStageConfig>
